"use client";

import { reopenConsentPrompt } from "@/lib/consent";

interface CookieSettingsLinkProps {
  className?: string;
}

/**
 * The "Cookie Settings" control the privacy policy promises: reopens the
 * consent banner so a visitor can change an earlier Accept/Reject decision.
 * A <button>, not a link — it doesn't navigate anywhere.
 */
export function CookieSettingsLink({ className }: CookieSettingsLinkProps) {
  return (
    <button type="button" onClick={() => reopenConsentPrompt()} className={className}>
      Cookie Settings
    </button>
  );
}
